import { useQuery } from '@tanstack/react-query';
import { minutesToMilliseconds } from 'date-fns';

import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { gqlClient } from '../../graphql-client';

const GetMyCalendarFeed = graphql(`
  query GetMyCalendarFeed {
    me {
      calendarFeed {
        url
        webcalUrl
      }
    }
  }
`);

const useGetMyCalendarFeed = () => {
  const { data, ...rest } = useQuery({
    queryKey: meKeys.calendarFeed(),
    queryFn: () => gqlClient.request(GetMyCalendarFeed),
    staleTime: minutesToMilliseconds(5),
  });

  return { calendarFeed: data?.me.calendarFeed, ...rest };
};

export default useGetMyCalendarFeed;
